import { createSlice } from '@reduxjs/toolkit';

const SLICE_NAME = 'forgotPasswordModalSlice';

export const forgotModalSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        isOpen: false,
    },
    reducers: {
        toggleForgotPasswordModal(state, action) {
            if (action.payload !== undefined) {
                state.isOpen = action.payload;
            } else {
                state.isOpen = !state.isOpen;
            }
        },
    },
});

export const { toggleForgotPasswordModal } = forgotModalSlice.actions;

export const forgotPasswordModal = forgotModalSlice.reducer;
